import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
//import { URLS } from 'common/urls';
import settings from 'common/configs/setting';
import timelineBg from 'assets/images/timeline-images/timeline-bg.png';

const getApiBase = () => {
    const url = localStorage.getItem('API_URL') || settings.url;
    return url.replace(/\/+$/, '');
};

const EmailChangeConfirm = () => {
    const [loading, setLoading] = useState(true);
    const [statusText, setStatusText] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [success, setSuccess] = useState(false);
    const hasFetched = useRef(false);

    useEffect(() => {
        let isMounted = true;
        if (hasFetched.current) {
            return;
        }
        hasFetched.current = true;

        const confirmEmail = async () => {
            try {
                const params = new URLSearchParams(window.location.search);
                const token = params.get('token');

                if (!token) {
                    if (isMounted) {
                        setErrorMsg('Token is required.');
                        setLoading(false);
                    }
                    return;
                }

                const response = await axios.get(
                    `${getApiBase()}/api/v2/account/email-change/confirm/?token=${token}`
                );

                if (isMounted) {
                    if (response.data && response.data.message) {
                        setStatusText(response.data.message);
                    } else {
                        setStatusText('Email address updated successfully.');
                    }
                    setSuccess(true);
                }
            } catch (err) {
                if (isMounted) {
                    const errorMsgResponse = err.response?.data?.error;

                    if (
                        errorMsgResponse ===
                        "Cannot confirm request in 'confirmed' status."
                    ) {
                        // Already confirmed — treat as success (handles React 18 strict-mode double-fire)
                        setStatusText(
                            'Your email address has already been confirmed.'
                        );
                        setSuccess(true);
                    } else if (
                        errorMsgResponse ===
                        'This email change link has expired.'
                    ) {
                        setErrorMsg(
                            'This link has expired. Please request a new email change.'
                        );
                    } else if (errorMsgResponse === 'Invalid token.') {
                        setErrorMsg(
                            'This link is invalid. Please request a new email change.'
                        );
                    } else if (
                        errorMsgResponse ===
                        'This email address is now in use by another account.'
                    ) {
                        setErrorMsg(
                            'This email address is already in use by another account. Please request a new email change with a different address.'
                        );
                    } else if (errorMsgResponse) {
                        setErrorMsg(errorMsgResponse);
                    } else {
                        setErrorMsg(
                            'An unexpected error occurred. Please try again.'
                        );
                    }
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        confirmEmail();

        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <>
            {/* JRNL's Native Background Layer */}
            <div className="bg-fill">
                <div
                    className="bg-fill__img"
                    style={{ backgroundImage: `url(${timelineBg})` }}
                />
            </div>
            <main id="login" className="email-change__main">
                <div className="email-change__container">
                    {loading ? (
                        <>
                            <div className="access__title email-change__title--loading">
                                Confirming Email...
                            </div>
                            <p className="email-change__text--muted">
                                Please wait while we verify your request.
                            </p>
                        </>
                    ) : success ? (
                        <>
                            <div className="access__title email-change__title--success">
                                Success!
                            </div>
                            <p className="email-change__text">{statusText}</p>
                        </>
                    ) : (
                        <>
                            <div className="access__title email-change__title--error">
                                Link Invalid or Expired
                            </div>
                            <p className="email-change__text">{errorMsg}</p>
                        </>
                    )}
                </div>
            </main>
        </>
    );
};

export default EmailChangeConfirm;
